<template>
  <div class="text-13 h-6 flex items-center">
    <template v-if="!leftText || !rightText"> {{ $t('evaluate_editor.action-execute-api') }} </template>
    <template v-else>
      <span><VariableChip :name="leftText" :index="6" class="mr-1 text-12" /></span> &nbsp; <span class="text-pink-500">{{ $t('equals') }}</span> &nbsp; <span>{{ rightText }}</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ApiOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  computed: {
    leftText() {
      return this.payload.variable;
    },
    rightText() {
      return `Data`;
    },
    payload() {
      return this.item.payload;
    },
  },
};
</script>
